import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import { TEST_TYPES } from '../../../constants/test';
import styles from './styles.scss';

export default class QcToggle extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  static get propTypes() {
    return {
      testType: PropTypes.string,
      onChange: PropTypes.func,
      isDynamicTest: PropTypes.bool,
    };
  }

  onChange(event) {
    const { onChange, isDynamicTest } = this.props;
    const { checked } = event.target;
    const testType = isDynamicTest ? TEST_TYPES.dinamicQc : TEST_TYPES.qc;
    onChange(checked ? testType : TEST_TYPES.test);
  }

  render() {
    const { testType, isDynamicTest } = this.props;
    const testTypeForCheck = isDynamicTest ? TEST_TYPES.dinamicQc : TEST_TYPES.qc;
    const checked = testType === testTypeForCheck;
    const className = checked ? styles.toggleActive : styles.toggleInactive;

    return (
      <label className="mb-3">
        <Toggle checked={checked} onChange={this.onChange} icons={false} className={className} />
        <span className="ml-2">QC Test</span>
      </label>
    );
  }
}



// WEBPACK FOOTER //
// src/components/testDetails/QCToggle/index.jsx